const RECIPE_ID = /^\d{1,12}$/;

/**
 * A recipe (experience) id: 1 to 12 digits, nothing else. Callers that allow
 * spaces around it trim first.
 */
export function isRecipeId(value: string): boolean {
  return RECIPE_ID.test(value);
}
